/* eslint-disable */
import {
  Tabs,
  Checkbox,
  Flex,
  message,
  Modal,
  Popover,
  Radio,
  Space,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "@/common.css";
import {
  CaretDownOutlined,
  ExclamationCircleOutlined,
  OneToOneOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import MainTable from "./component/MainTable";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { Link } from "react-router-dom";

export default function UserList() {
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [delList, setDelList] = useState([]);
  const [filtersData, setFiltersData] = useState([]);
  const childRef = useRef(); // 创建一个 ref 来引用子组件实例
 const [activeTab, setActiveTab] = useState('Ready To Pay');
  const deleteNum = (num) => {
    console.log(num);
    setDelList(num);
  };
  //调用子组件showModal方法

  const showModalThree = () => {
    console.log("==========刷新按钮============");
    if (childRef.current) {
      childRef.current.newListFun();
    }
  };
  // 切换
 const statusFilter = activeTab === 'Document Only' ? 'Document Only' : 'Ready To Pay';

  // 下载

const toEcexl = () => {
  Modal.confirm({
    title: "You are exporting Data based on Completed DateRange. Are you sure you want to download the data?",
    icon: <ExclamationCircleOutlined />,
    okText: "Sure",
    cancelText: "Cancel",
    async onOk() {
      try {
        // 获取子组件的查询参数
        const queryParams = childRef.current?.getQueryParams() || {};
        
        const params = { 
          ...queryParams,
          type: queryParams.type || statusFilter
        };

        const response = await http.get(`${api.getHistoryToExcel}`, {
          responseType: "blob",
          params,
        });

        if (response instanceof Blob) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;

          // 格式化日期作为文件名
          const today = new Date();
          const formattedDate = `${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}-${today.getFullYear()}`;
          const filename = `Maintenance History_${formattedDate}.xlsx`;
          
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          message.success("File downloaded successfully.");
        } else {
          throw new Error("Invalid response from server: Expected a Blob");
        }
      } catch (error) {
        console.error("Error:", error);
        message.error("An error occurred. Please try again.");
      }
    },
    onCancel() {
      console.log("Cancel");
    },
    style: {
      top: "40%",
    },
  });
};

  // 处理选项变化
  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>

  );
  const content2 = <a>Export to CSV</a>;

  // 获取子组件的值
  const getTableHead = () => {
    const list = childRef.current.getValue();
    setColumns(list);
    const transformedList = list.map((item) => ({
      label: item.dataIndex,
      value: item.key,
    }));
    console.log("columns", columns);
    setOptions(transformedList);
    const transformedList2 = list.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };
  const handleFilterChange = (filters) => {
    // console.log("Received filters:", filters);
    setFiltersData(filters);
  };
  // 使用 useEffect 在页面加载时执行方法
  useEffect(() => {
    console.log("页面加载时执行");
    getTableHead();
  }, []); // 依赖数组为空，确保只在组件首次加载时执行
  useEffect(() => {
  const hash = window.location.hash;
  const queryStart = hash.indexOf("?");

  if (queryStart !== -1) {
    const queryString = hash.substring(queryStart + 1);
    const searchParams = new URLSearchParams(queryString);
    const statusFilter = searchParams.get("statusFilter");

    if (statusFilter && statusFilter !== activeTab) {
      setActiveTab(statusFilter);
    }
  }
}, []);
  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div className="topLeft">
  
        <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
        items={[
          { label: "Ready To Pay", key: "Ready To Pay" },
          { label: "Document Only", key: "Document Only" },
        ]}
      />
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {commonFn.btnAuthorityFlag('Download') && <Radio.Button value="c" onClick={toEcexl}>
           
              <VerticalAlignBottomOutlined />
              <CaretDownOutlined className="ft12" />
    
            </Radio.Button> || null}
          </Radio.Group>
        </div>
      </Flex>
    
      <MainTable
        ref={childRef}
        deleteNum={deleteNum}
        onFilterChange={handleFilterChange}
          statusFilter={statusFilter} 
      ></MainTable>
    </div>
  );
}
